// Random nicknames: "{title} {noun}", e.g. "DJ Pinguino". Fun, local and short:
// every combination should fit 16 characters.
export default {
  pattern: '{title} {noun}',
  titles: [
    'DJ', 'MC', 'Lady', 'Mister', 'Miss', 'Capitan', 'Dottor', 'Maestro', 'Zio', 'Zia',
    'Baby', 'Lil', 'Big', 'King', 'Queen', 'Sir', 'Don', 'Mega', 'Super', 'Prof',
    'Conte', 'Duca', 'Madame', 'Signor', 'Nonna',
  ],
  nouns: [
    'Lasagna', 'Tortellino', 'Cannolo', 'Pistacchio', 'Arancino', 'Gnocco', 'Espresso',
    'Maritozzo', 'Carbonara', 'Panettone', 'Gorgonzola', 'Grissino', 'Tiramisù', 'Zucchina',
    'Melanzana', 'Cornetto', 'Babà', 'Bombolone', 'Carciofo', 'Lupino', 'Pomodoro',
    'Limone', 'Peperoncino', 'Basilico', 'Mozzarella', 'Frittata', 'Piadina', 'Cantucci',
    'Pinguino', 'Bassotto', 'Fenicottero', 'Riccio', 'Polpo', 'Bradipo', 'Koala', 'Criceto',
    'Alpaca', 'Panda', 'Tucano', 'Geco', 'Castoro', 'Procione', 'Delfino', 'Capibara',
    'Orsetto', 'Gufo', 'Lama', 'Gattone', 'Fagiano', 'Lumaca', 'Axolotl',
    'Vinile', 'Mandolino', 'Tamburello', 'Cassetta', 'Subwoofer', 'Giradischi', 'Ukulele',
    'Triangolo', 'Maracas', 'Theremin', 'Ottavino', 'Metronomo', 'Kazoo', 'Bongo',
    'Falsetto', 'Ritornello', 'Assolo', 'Bemolle', 'Diesis', 'Remix', 'Karaoke', 'Jukebox',
    'Cuffietta', 'Vocoder', 'Glitter', 'Stereo',
  ],
}
